
import 'bootstrap'
import 'font-awesome/css/font-awesome.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../css/engineering-calculator.css' 

import './components/nav-bar/nav-bar-component.js'
import './components/footer-component.js'

import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

let dispGraph = null
let thetaGraph = null
let shearGraph = null
let momentGraph = null

//set up on beam click
for(let i = 0; i <= 16; i++) {
  document.getElementById(`beam-${i}`).onclick = () => onBeamSelected(i)
}

document.getElementById('set-english-units').onclick = setEnglishUnits
document.getElementById('set-metric-units').onclick = setMetricUnits

document.getElementById('E-input').onchange = recalculate
document.getElementById('I-input').onchange = recalculate

const ENGLISH_UNITS = "english";
const METRIC_UNITS = "metric";
let gUnits = ENGLISH_UNITS;
const M_PI = 3.14159265;

const nDataPoints = 10;
var beams = [];
var cachedIndex = 1;

function changeUnits(cssClassName, newUnitStr) {
  const elements = document.getElementsByClassName(cssClassName)
  for (let i = 0; i < elements.length; i += 1) {
    elements.item(i).innerHTML = newUnitStr
  }
}

function setUnits() {
  if (gUnits === ENGLISH_UNITS) {
    changeUnits('units-force', 'kips')
    changeUnits('units-force-per-length', 'kips/in')
    changeUnits('units-pressure', 'ksi')
    changeUnits('units-moment', 'kip-in')
    changeUnits('units-length', 'in')
  } else {
    changeUnits('units-force', 'kN')
    changeUnits('units-force-per-length', 'kN/m')
    changeUnits('units-pressure', 'kPa')
    changeUnits('units-moment', 'kN-m')
    changeUnits('units-length', 'm')
  }
}

function setEnglishUnits() {
  gUnits = ENGLISH_UNITS
  setUnits()
  document.getElementById('units-dropdown').innerHTML = "English (inches, kips, ksi)"
}

function setMetricUnits() {
  gUnits = METRIC_UNITS
  setUnits()
  document.getElementById('units-dropdown').innerHTML = "Metric (meters, kN, kPa)"
}

function getLength(index) {
  switch (index) {
    //simply supported beams
    case 2:
    case 5:
    //cantilevers
    case 12:
    case 14:
      return Number(document.getElementById('b-input').value) + Number(document.getElementById('a-input').value)
  }
  return Number(document.getElementById('L-input').value)
}

function getDimensionsAndLoad(index) {
  var res = {};
  res.E = document.getElementById("E-input").value
  res.I = document.getElementById("I-input").value
  res.M = document.getElementById("M-input") ? document.getElementById("M-input").value : 0
  res.q = document.getElementById("q-input") ? document.getElementById("q-input").value : 0
  res.p = document.getElementById("P-input") ? document.getElementById("P-input").value : 0
  res.a = document.getElementById("a-input") ? document.getElementById("a-input").value : 0
  res.b = document.getElementById("b-input") ? document.getElementById("b-input").value : 0
  res.L = getLength(index)
  res.beamID = index + 1
  return res
}

function showDataTable(displacements, thetas, moments, shears) {
  let longestArray
  let str = '<table class="table table-striped table-hover">';
  str += '<tr><th>x (<span class="units-length"></span>)</th>';
  str += '<th>Displacement (<span class="units-length"></span>)</th>';
  str += '<th>Slope (degrees)</th>';
  str += '<th>Moment (<span class="units-moment"></span>)</th>';
  str += '<th>Shear (<span class="units-force"></span>)</th></tr>';

  let maxLength = Math.max(displacements.length, thetas.length);
  maxLength = Math.max(maxLength, moments.length);
  maxLength = Math.max(maxLength, shears.length);

  longestArray = displacements;
  if (thetas.length > displacements.length) {
    longestArray = thetas;
  }
  if (moments.length > thetas.length) {
    longestArray = moments;
  }
  if (shears.length > moments.length) {
    longestArray = shears;
  }

  function makeMap(array) {
    let map = {}
    for (let i = 0; i < array.length; i += 1) {
      let x = parseFloat(array[i][0]).toPrecision(5);
      let r = parseFloat(array[i][1]).toPrecision(5);
      if (x in map) {
        map[x].push(r);
      } else {
        map[x] = [r];
      }
    }
    return map;
  }

  const d = makeMap(displacements);
  const t = makeMap(thetas);
  const m = makeMap(moments);
  const s = makeMap(shears);

  function pop(element) {
    var r = element.pop();
    if (r === undefined) {
      return '--';
    }
    return r;
  }

  for (let i = 0; i < longestArray.length; i += 1) {
    if (longestArray[i] !== undefined && longestArray[i][0] !== undefined) {
      const x = parseFloat(longestArray[i][0]).toPrecision(5);
      str += "<tr><td>" + x + "</td>";
      str += "<td>" + pop(d[x]) + "</td>";
      str += "<td>" + pop(t[x]) + "</td>";
      str += "<td>" + pop(m[x]) + "</td>";
      str += "<td>" + pop(s[x]) + "</td></tr>";
    }
  }
  str += "</table>";
  document.getElementById("result-table").innerHTML = str;
}

function showExtremes(displacements, thetas, moments, shears) {
  function setExtremes(array, maxId, locId) {
    var i, max = array[0][1], max_at = array[0][0];
    for (i = 0; i < array.length; i++) {
      if (Math.abs(array[i][1]) > max) {
        max = Math.abs(array[i][1]);
        max_at = array[i][0];
      }
    }
    document.getElementById(maxId).innerHTML = parseFloat(max).toPrecision(5)
    document.getElementById(locId).innerHTML = parseFloat(max_at).toPrecision(5)
  }

  setExtremes(displacements, 'max-displacement', 'max-displacement-location');
  setExtremes(shears, 'max-shear', 'max-shear-location');
  setExtremes(moments, 'max-moment', 'max-moment-location');
}

function BeamClass() {
  this.imagePath = "";
  this.eqnImagePath = "";
  this.dimensions = [];
  this.isPiecewise = false;
  this.a = -1;
}

BeamClass.prototype.AddDimension = function (dimName, defaultValue, unit) {
  this.dimensions.push({ name: dimName, value: defaultValue, unit: unit });
};

BeamClass.prototype.SetupImages = function () {
  let str = '<img src="' + this.imagePath + '" width="160px" alt="beam image"/>'
  document.getElementById('current-beam-image').innerHTML = str
  str = '<img src="' + this.eqnImagePath + '" alt="beam equation"/>'
  document.getElementById('current-beam-equations').innerHTML = str
};

/**
 * set up the beam dimensions form
 * requires <div id="dimensions"> on the html page
 * */
BeamClass.prototype.SetupDimensionForm = function (index) {
  //put the user dimensions on the worksheet
  var i, label, value, unit, text = "<form name='beam_data'>";
  for (i = 0; i < this.dimensions.length; i += 1) {
    if (this.dimensions[i] !== undefined) {
      label = this.dimensions[i].name;
      value = this.dimensions[i].value;
      unit = this.dimensions[i].unit;
      text += '<div class="form-group">';
      text += '<label class="control-label" for="' + label + '-input"><i>' + label + ' (<span class="' + unit + '"></span>)</i></label>';
      text += '<input class="form-control" type="text" id="' + label + '-input" value="' + value + '" ></div>';
    }
  }

  text += '<div class="form-group">';
  text += '<label class="control-label" for="x-input"><i>point of interest, x (<span class="units-length"></span>)</i></label>';
  text += '<input class="form-control" type="text" id="x-input" value="60"></div>';
  document.getElementById('dimensions').innerHTML = text
  document.getElementById('calculate-button').innerHTML = '<p class="btn btn-success btn-md" role="button">Calculate</p>'

  for (i = 0; i < this.dimensions.length; i += 1) {
    document.getElementById(`${this.dimensions[i].name}-input`).onchange = recalculate
  }

  document.getElementById('x-input').onchange = recalculate

  document.getElementById('calculate-button').onclick = () => onCalculateButtonTap(index)
};

//simple beam 1
var simpleBeam1 = new BeamClass();
simpleBeam1.imagePath = "./beam-calculator/images/simple-1.png";
simpleBeam1.eqnImagePath = "./beam-calculator/images/simple_1_eqns.png";
simpleBeam1.AddDimension("q", "1", "units-force-per-length");
simpleBeam1.AddDimension("L", "120", "units-length");
beams.push(simpleBeam1);

//simple beam 2
var simpleBeam2 = new BeamClass();
simpleBeam2.imagePath = "./beam-calculator/images/simple-2.png";
simpleBeam2.eqnImagePath = "./beam-calculator/images/simple_2_eqns.png";
simpleBeam2.AddDimension("q", "1", "units-force-per-length");
simpleBeam2.AddDimension("a", "60", "units-length");
simpleBeam2.AddDimension("L", "120", "units-length");
beams.push(simpleBeam2);

var simpleBeam3 = new BeamClass();
simpleBeam3.imagePath = "./beam-calculator/images/simple-3.png";
simpleBeam3.eqnImagePath = "./beam-calculator/images/simple_3_eqns.png";
simpleBeam3.AddDimension("a", "60", "units-length");
simpleBeam3.AddDimension("b", "60", "units-length");
simpleBeam3.AddDimension("P", "1", "units-force");
beams.push(simpleBeam3);

var simpleBeam4 = new BeamClass();
simpleBeam4.imagePath = "./beam-calculator/images/simple-4.png";
simpleBeam4.eqnImagePath = "./beam-calculator/images/simple_4_eqns.png";
simpleBeam4.AddDimension("a", "60", "units-length");
simpleBeam4.AddDimension("L", "120", "units-length");
simpleBeam4.AddDimension("P", "1", "units-force");
beams.push(simpleBeam4);

var simpleBeam5 = new BeamClass();
simpleBeam5.imagePath = "./beam-calculator/images/simple-5.png";
simpleBeam5.eqnImagePath = "./beam-calculator/images/simple_5_eqns.png";
simpleBeam5.AddDimension("M", "10", "units-moment");
simpleBeam5.AddDimension("L", "120", "units-length");
beams.push(simpleBeam5);

//moment located at "a" AND a >= L/2!
var simpleBeam6 = new BeamClass();
simpleBeam6.imagePath = "./beam-calculator/images/simple-6.png";
simpleBeam6.eqnImagePath = "./beam-calculator/images/simple_6_eqns.png";
simpleBeam6.AddDimension("M", "10", "units-moment");
simpleBeam6.AddDimension("a", "60", "units-length");
simpleBeam6.AddDimension("b", "60", "units-length");
beams.push(simpleBeam6);

var simpleBeam7 = new BeamClass();
simpleBeam7.imagePath = "./beam-calculator/images/simple-7.png";
simpleBeam7.eqnImagePath = "./beam-calculator/images/simple_7_eqns.png";
simpleBeam7.AddDimension("M", "10", "units-moment");
simpleBeam7.AddDimension("L", "120", "units-length");
beams.push(simpleBeam7);

var simpleBeam8 = new BeamClass();
simpleBeam8.imagePath = "./beam-calculator/images/simple-8.png";
simpleBeam8.eqnImagePath = "./beam-calculator/images/simple_8_eqns.png";
simpleBeam8.AddDimension("q", "1", "units-force-per-length");
simpleBeam8.AddDimension("L", "120", "units-length");
beams.push(simpleBeam8);

var simpleBeam9 = new BeamClass();
simpleBeam9.imagePath = "./beam-calculator/images/simple-9.png";
simpleBeam9.eqnImagePath = "./beam-calculator/images/simple_9_eqns.png";
simpleBeam9.AddDimension("q", "1", "units-force-per-length");
simpleBeam9.AddDimension("L", "120", "units-length");
beams.push(simpleBeam9);

//cantilevers...
//cantilever beam 1
var cantileverBeam1 = new BeamClass();
cantileverBeam1.imagePath = "./beam-calculator/images/cantilever-1.png";
cantileverBeam1.eqnImagePath = "./beam-calculator/images/cantilever_1_eqns.png";
cantileverBeam1.AddDimension("q", "1", "units-force-per-length");
cantileverBeam1.AddDimension("L", "120", "units-length");
beams.push(cantileverBeam1);

//cantilever beam 2
var cantileverBeam2 = new BeamClass();
cantileverBeam2.imagePath = "./beam-calculator/images/cantilever-2.png";
cantileverBeam2.eqnImagePath = "./beam-calculator/images/cantilever_2_eqns.png";
cantileverBeam2.AddDimension("q", "1", "units-force-per-length");
cantileverBeam2.AddDimension("a", "25", "units-length");
cantileverBeam2.AddDimension("L", "120", "units-length");
beams.push(cantileverBeam2);

/* note: previous version removed cantilever 3 due to incorrect equations and calcs
   equation image numbers will be off by one from this point forward
var cantileverBeam3 = new BeamClass();
cantileverBeam3.imagePath = "./beam-calculator/images/cantilever-3.png";
cantileverBeam3.eqnImagePath = "./beam-calculator/images/cantilever_3_eqns.png";
cantileverBeam3.AddDimension( "a", "50", "units-length");
cantileverBeam3.AddDimension( "b", "50", "units-length");
cantileverBeam3.AddDimension( "q", "1", "units-force-per-length");
beams.push( cantileverBeam3 );
*/

var cantileverBeam3 = new BeamClass();
cantileverBeam3.imagePath = "./beam-calculator/images/cantilever-3.png";
cantileverBeam3.eqnImagePath = "./beam-calculator/images/cantilever_4_eqns.png";
cantileverBeam3.AddDimension("L", "120", "units-length");
cantileverBeam3.AddDimension("P", "1", "units-force");
beams.push(cantileverBeam3);

var cantileverBeam4 = new BeamClass();
cantileverBeam4.imagePath = "./beam-calculator/images/cantilever-4.png";
cantileverBeam4.eqnImagePath = "./beam-calculator/images/cantilever_5_eqns.png";
cantileverBeam4.AddDimension("a", "60", "units-length");
cantileverBeam4.AddDimension("b", "60", "units-length");
cantileverBeam4.AddDimension("P", "1", "units-force");
beams.push(cantileverBeam4);

//moment located at "a" AND a >= L/2!
var cantileverBeam5 = new BeamClass();
cantileverBeam5.imagePath = "./beam-calculator/images/cantilever-5.png";
cantileverBeam5.eqnImagePath = "./beam-calculator/images/cantilever_6_eqns.png";
cantileverBeam5.AddDimension("L", "120", "units-length");
cantileverBeam5.AddDimension("M", "1", "units-moment");
beams.push(cantileverBeam5);

var cantileverBeam6 = new BeamClass();
cantileverBeam6.imagePath = "./beam-calculator/images/cantilever-6.png";
cantileverBeam6.eqnImagePath = "./beam-calculator/images/cantilever_7_eqns.png";
cantileverBeam6.AddDimension("a", "60", "units-length");
cantileverBeam6.AddDimension("b", "60", "units-length");
cantileverBeam6.AddDimension("M", "1", "units-moment");
beams.push(cantileverBeam6);

var cantileverBeam7 = new BeamClass();
cantileverBeam7.imagePath = "./beam-calculator/images/cantilever-7.png";
cantileverBeam7.eqnImagePath = "./beam-calculator/images/cantilever_8_eqns.png";
cantileverBeam7.AddDimension("q", "1", "units-force-per-length");
cantileverBeam7.AddDimension("L", "120", "units-length");
beams.push(cantileverBeam7);

var cantileverBeam8 = new BeamClass();
cantileverBeam8.imagePath = "./beam-calculator/images/cantilever-8.png";
cantileverBeam8.eqnImagePath = "./beam-calculator/images/cantilever_9_eqns.png";
cantileverBeam8.AddDimension("q", "1", "units-force-per-length");
cantileverBeam8.AddDimension("L", "120", "units-length");
beams.push(cantileverBeam8);

function delta(index, nPoints) {
  const deltas = []
  const points = []
  let res = 0
  const E = document.getElementById("E-input").value
  const I = document.getElementById("I-input").value
  const M = document.getElementById("M-input") ? document.getElementById("M-input").value : 0
  const q = document.getElementById("q-input") ? document.getElementById("q-input").value : 0
  const P = document.getElementById("P-input") ? document.getElementById("P-input").value : 0
  const a = document.getElementById("a-input") ? document.getElementById("a-input").value : 0
  const b = document.getElementById("b-input") ? document.getElementById("b-input").value : 0
  const x_prime = document.getElementById("x-input") ? document.getElementById("x-input").value : 0
  const L = getLength(index)
  const beamID = index + 1

  for (let i = 0; i <= nPoints; i += 1) {
    const x = i / nPoints * L
    points.push(x)
    if (x_prime > x && x_prime < (i + 1) / nPoints * L) {
      points.push(parseFloat(x_prime));
    }
  }

  for (let i = 0; i < points.length; i += 1) {
    const x = points[i];
    if (beamID === 1) {
      res = (q * x) / (24 * E * I) * (L * L * L - 2 * L * x * x + x * x * x);
    } else if (beamID === 2) {
      //L is actually length 2 input for this one
      if (x <= a) {
        res = (q * x) / (24 * L * E * I) * (Math.pow(a, 4) - 4 * Math.pow(a, 3) * L + 4 * Math.pow(a, 2) * Math.pow(L, 2) + 2 * Math.pow(a, 2) * Math.pow(x, 2) - 4 * a * L * Math.pow(x, 2) + L * Math.pow(x, 3));
      } else {
        res = (q * Math.pow(a, 2)) / (24 * L * E * I) * (-Math.pow(a, 2) * L + 4 * Math.pow(L, 2) * x + Math.pow(a, 2) * x - 6 * L * Math.pow(x, 2) + 2 * Math.pow(x, 3));
      }
    } else if (beamID === 3) {
      if (x <= a) {
        res = (P * b * x) / (6 * L * E * I) * (L * L - b * b - x * x);
      } else {
        res = (P * a * (x - L)) / (6 * L * E * I) * (a * a - 2 * L * x + x * x);
      }
    } else if (beamID === 4) {
      if (x <= a) {
        res = (P * x) / (6 * E * I) * (3 * a * L - 3 * a * a - x * x);
      } else if (x <= L - a) {
        res = (P * a) / (6 * E * I) * (3 * L * x - 3 * x * x - a * a);
      } else {
        res = -(P * (x - L)) / (6 * E * I) * (3 * a * L - 3 * a * a - (x - L) * (x - L));
      }
    } else if (beamID === 5) {
      res = (M * x) / (6 * E * I * L) * (2 * L * L - 3 * L * x + x * x);
    } else if (beamID === 6) {
      if (x <= a) {
        res = (M * x) / (6 * L * E * I) * (6 * a * L - 3 * a * a - 2 * L * L - x * x);
      } else {
        res = -(M * (L - x)) / (6 * L * E * I) * (6 * b * L - 3 * b * b - 2 * L * L - (L - x) * (L - x));
      }
    } else if (beamID === 7) {
      res = (M * x) / (2 * E * I) * (L - x);
    } else if (beamID === 8) {
      res = (q * x) / (360 * L * E * I) * (7 * Math.pow(L, 4) - 10 * L * L * x * x + 3 * Math.pow(x, 4));
    } else if (beamID === 9) {
      if (x <= L / 2) {
        res = (q * x) / (960 * L * E * I) * (5 * L * L - 4 * x * x) * (5 * L * L - 4 * x * x);
      } else {
        res = -(q * (x - L)) / (960 * L * E * I) * (5 * L * L - 4 * (x - L) * (x - L)) * (5 * L * L - 4 * (x - L) * (x - L));
      }
    }
    //cantilevers
    else if (beamID === 10) {
      res = (q * x * x) / (24 * E * I) * (6 * L * L - 4 * L * x + x * x);
    } else if (beamID === 11) {
      if (x <= a) {
        res = (q * x * x) / (24 * E * I) * (6 * a * a - 4 * a * x + x * x);
      } else {
        res = (q * a * a * a) / 24 / E / I * (4 * x - a);
      }
    } else if (beamID === 12) {
      res = (P * x * x) / (6 * E * I) * (3 * L - x);
    } else if (beamID === 13) {
      if (x <= a) {
        res = (P * x * x) / (6 * E * I) * (3 * a - x);
      } else {
        res = (P * a * a) / (6 * E * I) * (3 * x - a);
      }
    } else if (beamID === 14) {
      res = (M * x * x) / (2 * E * I);
    } else if (beamID === 15) {
      if (x <= a) {
        res = (M * x * x) / (2 * E * I);
      } else {
        res = (M * a) / (2 * E * I) * (2 * x - a);
      }
    } else if (beamID === 16) {
      res = (q * x * x) / (120 * L * E * I) * (10 * L * L * L - 10 * L * L * x + 5 * L * x * x - x * x * x);
    } else if (beamID === 17) {
      res = (q * x * x) / (120 * L * E * I) * (20 * L * L * L - 10 * L * L * x + x * x * x);
    }
    deltas.push([x, res]);
  }
  return deltas;
}

function theta(index, nPoints) {
  const thetas = []
  const points = []
  let res = 0
  let x = 0
  const E = document.getElementById("E-input").value
  const I = document.getElementById("I-input").value
  const M = document.getElementById("M-input") ? document.getElementById("M-input").value : 0
  const q = document.getElementById("q-input") ? document.getElementById("q-input").value : 0
  const P = document.getElementById("P-input") ? document.getElementById("P-input").value : 0
  const a = document.getElementById("a-input") ? document.getElementById("a-input").value : 0
  const b = document.getElementById("b-input") ? document.getElementById("b-input").value : 0
  const x_prime = document.getElementById("x-input") ? document.getElementById("x-input").value : 0
  const L = getLength(index)
  const beamID = index + 1

  for (let i = 0; i <= nPoints; i += 1) {
    x = i / nPoints * L;
    points.push(x);
    if (x_prime > x && x_prime < (i + 1) / nPoints * L) {
      points.push(x_prime * 1.0);
    }
  }

  for (let i = 0; i < points.length; i += 1) {
    x = points[i];
    if (beamID === 1) {
      res = q / (24 * E * I) * (L * L * L - 6 * L * x * x + 4 * x * x * x);
    } else if (beamID === 2) {
      if (x <= a) {
        res = q / (24 * L * E * I) * (Math.pow(a, 4) - 4 * Math.pow(a, 3) * L + 4 * Math.pow(a, 2) * Math.pow(L, 2) + 6 * Math.pow(a, 2) * Math.pow(x, 2) - 12 * a * L * Math.pow(x, 2) + 4 * L * Math.pow(x, 3));
      } else {
        res = (q * Math.pow(a, 2)) / (24 * L * E * I) * (4 * Math.pow(L, 2) + Math.pow(a, 2) - 12 * L * x + 6 * Math.pow(x, 2));
      }
    } else if (beamID === 3) {
      if (x <= a) {
        res = (P * b) / (6 * L * E * I) * (L * L - b * b - 3 * x * x);
      } else {
        res = (P * a) / (6 * L * E * I) * (a * a - 6 * L * x + 3 * x * x + 2 * L * L);
      }
    } else if (beamID === 4) {
      if (x <= a) {
        res = P / (2 * E * I) * (a * L - a * a - x * x);
      } else if (x <= L - a) {
        res = (P * a) / (2 * E * I) * (L - 2 * x);
      } else {
        res = -P / (2 * E * I) * (a * L - a * a - (L - x) * (L - x));
      }
    } else if (beamID === 5) {
      res = M / (6 * E * I * L) * (2 * L * L - 6 * L * x + 3 * x * x);
    } else if (beamID === 6) {
      if (x <= a) {
        res = M / (6 * L * E * I) * (6 * a * L - 3 * a * a - 2 * L * L - 3 * x * x);
      } else {
        res = M / (6 * L * E * I) * (6 * b * L - 3 * b * b - 2 * L * L - 3 * (x - L) * (x - L));
      }
    } else if (beamID === 7) {
      res = M / (2 * E * I) * (L - 2 * x);
    } else if (beamID === 8) {
      res = q / (360 * L * E * I) * (7 * Math.pow(L, 4) - 30 * L * L * x * x + 15 * Math.pow(x, 4));
    } else if (beamID === 9) {
      if (x <= L / 2) {
        res = q / (192 * L * E * I) * (5 * L * L - 4 * x * x) * (L * L - 4 * x * x);
      } else {
        res = -q / (192 * L * E * I) * (5 * L * L - 4 * (x - L) * (x - L)) * (L * L - 4 * (x - L) * (x - L));
      }
    }
    //cantilevers
    else if (beamID === 10) {
      res = (q * x) / (6 * E * I) * (3 * L * L - 3 * L * x + x * x);
    } else if (beamID === 11) {
      if (x <= a) {
        res = (q * x) / (6 * E * I) * (3 * a * a - 3 * a * x + x * x);
      } else {
        res = q * a * a * a / 6 / E / I;
      }
    }
    /*else if(beamID == 11 ){
        //alert( "L= " + L + " a= " + a + " b= " + b + " x=" + x);
        if( x <= a){
            theta = 0;//(q*b*x)/(2*E*I)*(L+a-x);
            //alert( x );
        }
        else
            theta = q/6/E/I*(Math.pow(x,3)-3*L*x*x+3*L*L*x-Math.pow(a,3));
        //alert( theta );
    }*/
    else if (beamID === 12) {
      res = (P * x) / (2 * E * I) * (2 * L - x);
    } else if (beamID === 13) {
      if (x <= a) {
        res = (P * x) / (2 * E * I) * (2 * a - x);
      } else {
        res = (P * a * a) / (2 * E * I);
      }
    } else if (beamID === 14) {
      res = (M * x) / (E * I);
    } else if (beamID === 15) {
      if (x <= a) {
        res = (M * x) / (E * I);
      } else {
        res = (M * a) / (E * I);
      }
    } else if (beamID === 16) {
      res = (q * x) / (24 * L * E * I) * (4 * L * L * L - 6 * L * L * x + 4 * L * x * x - x * x * x);
    } else if (beamID === 17) {
      res = (q * x) / (24 * L * E * I) * (8 * L * L * L - 6 * L * L * x + x * x * x);
    }

    res *= 180 / M_PI;
    thetas.push([x, res]);
  }

  return thetas;
}

function moment(index, nPoints) {
  const moments = []
  const points = []
  let res = 0
  let x = 0
  const M = document.getElementById("M-input") ? document.getElementById("M-input").value : 0
  const q = document.getElementById("q-input") ? document.getElementById("q-input").value : 0
  const P = document.getElementById("P-input") ? document.getElementById("P-input").value : 0
  const a = document.getElementById("a-input") ? document.getElementById("a-input").value : 0
  const b = document.getElementById("b-input") ? document.getElementById("b-input").value : 0
  const x_prime = document.getElementById("x-input") ? document.getElementById("x-input").value : 0
  const L = getLength(index)
  const beamID = index + 1

  for (let i = 0; i <= nPoints; i += 1) {
    x = i / nPoints * L;
    points.push(x);
    if (x_prime > x && x_prime < (i + 1) / nPoints * L) {
      points.push(x_prime * 1.0);
    }
  }

  for (let i = 0; i < points.length; i += 1) {
    x = points[i];
    if (beamID === 1) {
      res = (q * x) / 2 * (x - L);
      moments.push([x, res]);
    } else if (beamID === 2) {
      if (x <= a) {
        res = (q * x) / (2 * L) * (Math.pow(a, 2) - 2 * a * L + L * x);
        moments.push([x, res]);
      }
      if (x >= a) {
        res = (-q * a * a) / (2 * L) * (L - x);
        moments.push([x, res]);
      }
    } else if (beamID === 3) {
      if (x <= a) {
        res = -(P * b * x) / L;
        moments.push([x, res]);
      }
      if (x >= a) {
        res = -(P * a) / L * (L - x);
        moments.push([x, res]);
      }
    } else if (beamID === 4) {
      if (x <= a) {
        res = -P * x;
        moments.push([x, res]);
      }
      if (x >= a && x <= L - a) {
        res = -P * a;
        moments.push([x, res]);
      }
      if (x >= L - a) {
        res = -P * (L - x);
        moments.push([x, res]);
      }
    } else if (beamID === 5) {
      res = M / L * (x - L);
      moments.push([x, res]);
    } else if (beamID === 6) {
      if (x <= a) {
        res = -(M * x) / L;
        moments.push([x, res]);
      }
      if (x >= a) {
        res = -M / L * (x - L);
        moments.push([x, res]);
      }
    } else if (beamID === 7) {
      res = -M;
      moments.push([x, res]);
    } else if (beamID === 8) {
      res = (q * x) / (6 * L) * (x * x - L * L);
      moments.push([x, res]);
    } else if (beamID === 9) {
      if (x <= L / 2) {
        res = (q * x) / (12 * L) * (4 * x * x - 3 * L * L);
        moments.push([x, res]);
      }
      if (x >= L / 2) {
        res = -(q * (x - L)) / (12 * L) * (4 * (x - L) * (x - L) - 3 * L * L);
        moments.push([x, res]);
      }
    }
    //cantilevers
    else if (beamID === 10) {
      res = q / 2 * (L * L - 2 * L * x + x * x);
      moments.push([x, res]);
    } else if (beamID === 11) {
      if (x <= a) {
        res = (q / 2) * (a * a - 2 * a * x + x * x);
        moments.push([x, res]);
      }
      if (x >= a) {
        res = 0;
        moments.push([x, res]);
      }
    } else if (beamID === 12) {
      res = P * (x - L);
      moments.push([x, res]);
    } else if (beamID === 13) {
      if (x <= a) {
        res = P * (x - a);
        moments.push([x, res]);
      }
      if (x >= a) {
        res = 0;
        moments.push([x, res]);
      }
    } else if (beamID === 14) {
      res = -M;
      moments.push([x, res]);
    } else if (beamID === 15) {
      if (x <= a) {
        res = -M;
        moments.push([x, res]);
      }
      if (x >= a) {
        res = 0;
        moments.push([x, res]);
      }
    } else if (beamID === 16) {
      res = q / (6 * L) * (L * L * L - 3 * L * L * x + 3 * L * x * x - x * x * x);
      moments.push([x, res]);
    } else if (beamID === 17) {
      res = q / (6 * L) * (2 * L * L * L - 3 * L * L * x + x * x * x);
      moments.push([x, res]);
    }
  }

  return moments;
}

function shear(index, nPoints) {
  const shears = []
  const points = []
  let res = 0
  let x = 0
  const M = document.getElementById("M-input") ? document.getElementById("M-input").value : 0
  const q = document.getElementById("q-input") ? document.getElementById("q-input").value : 0
  const P = document.getElementById("P-input") ? document.getElementById("P-input").value : 0
  const a = document.getElementById("a-input") ? document.getElementById("a-input").value : 0
  const b = document.getElementById("b-input") ? document.getElementById("b-input").value : 0
  const x_prime = document.getElementById("x-input") ? document.getElementById("x-input").value : 0
  const L = getLength(index)
  const beamID = index + 1

  for (let i = 0; i <= nPoints; i += 1) {
    x = i / nPoints * L;
    points.push(x);
    if (x_prime > x && x_prime < (i + 1) / nPoints * L) {
      points.push(x_prime * 1.0);
    }
  }

  for (let i = 0; i < points.length; i += 1) {
    x = points[i];
    if (beamID === 1) {
      res = q / 2 * (2 * x - L);
      shears.push([x, res]);
    } else if (beamID === 2) {
      if (x <= a) {
        res = q / (2 * L) * (Math.pow(a, 2) - 2 * a * L + 2 * L * x);
        shears.push([x, res]);
      }
      if (x >= a) {
        res = (q * a * a) / (2 * L);
        shears.push([x, res]);
      }
    } else if (beamID === 3) {
      if (x <= a) {
        res = -(P * b) / L;
        shears.push([x, res]);
      }
      if (x >= a) {
        res = P * a / L;
        shears.push([x, res]);
      }
    } else if (beamID === 4) {
      if (x <= a) {
        res = -P;
        shears.push([x, res]);
      }
      if (x <= L - a && x >= a) {
        res = 0;
        shears.push([x, res]);
      }
      if (x >= L - a) {
        res = P;
        shears.push([x, res]);
      }
    } else if (beamID === 5) {
      res = M / L;
      shears.push([x, res]);
    } else if (beamID === 6) {
      res = -M / L;
      shears.push([x, res]);
    } else if (beamID === 7) {
      res = 0;
      shears.push([x, res]);
    } else if (beamID === 8) {
      res = q / (6 * L) * (3 * x * x - L * L);
      shears.push([x, res]);
    } else if (beamID === 9) {
      if (x <= L / 2) {
        res = q / (4 * L) * (4 * x * x - L * L);
        shears.push([x, res]);
      }
      if (x >= L / 2) {
        res = -q / (4 * L) * (4 * (x - L) * (x - L) - L * L);
        shears.push([x, res]);
      }
    }
    //cantilevers
    else if (beamID === 10) {
      res = q * (x - L);
      shears.push([x, res]);
    } else if (beamID === 11) {
      if (x <= a) {
        res = q * (x - a);
        shears.push([x, res]);
      }
      if (x >= a) {
        res = 0;
        shears.push([x, res]);
      }
    } else if (beamID === 12) {
      res = P;
      shears.push([x, res]);
    } else if (beamID === 13) {
      if (x <= a) {
        res = P;
        shears.push([x, res]);
      }
      if (x >= a) {
        res = 0;
        shears.push([x, res]);
      }
    } else if (beamID === 14) {
      res = 0;
      shears.push([x, res]);
    } else if (beamID === 15) {
      res = 0;
      shears.push([x, res]);
    } else if (beamID === 16) {
      res = -q / (2 * L) * (L * L - 2 * L * x + x * x);
      shears.push([x, res]);
    } else if (beamID === 17) {
      res = q / (2 * L) * (-L * L + x * x);
      shears.push([x, res]);
    }
  }

  return shears;
}

function calculate(index) {
  var deltas, thetas, moments, shears;
  cachedIndex = index;
  deltas = delta(index, nDataPoints);
  thetas = theta(index, nDataPoints);
  moments = moment(index, nDataPoints);
  shears = shear(index, nDataPoints);

  if(dispGraph) { dispGraph.destroy() }
  dispGraph = showPlot(deltas, 'displacement-chart')

  if(thetaGraph) { thetaGraph.destroy() }
  thetaGraph = showPlot(thetas, 'theta-chart')

  if(momentGraph) { momentGraph.destroy() }
  momentGraph = showPlot(moments, 'moment-chart')

  if(shearGraph) { shearGraph.destroy() }
  shearGraph = showPlot(shears, 'shear-chart')

  showDataTable(deltas, thetas, moments, shears);
  showExtremes(deltas, thetas, moments, shears);
  setUnits()
}

function onCalculateButtonTap(index) {
  calculate(index);
  const y = document.getElementById('beam-plots-top').getBoundingClientRect().top + window.scrollY - 50
  window.scroll({ top: y, behavior: 'smooth'})
}

function recalculate() {
  calculate(cachedIndex);
}

function onBeamSelected(index) {
  beams[index].SetupImages();
  beams[index].SetupDimensionForm(index);
  //set the class to selected, clear others
  //document.getElementById("beam-selector").children().children().removeClass("selected");
  //document.getElementById("simply-supported").children().removeClass("selected");
  //document.getElementById("cantilever").children().removeClass("selected");
  //document.getElementById("beam-" + index).addClass("selected");
  calculate(index);
  const y = document.getElementById('beam-drawing-top').getBoundingClientRect().top + window.scrollY - 50
  window.scroll({ top: y, behavior: 'smooth'})
}

function showPlot(points, element) {
  // convert from [x, y] to {x: x, y: y}
  let p = points.map( (p) => {
    return {'x': p[0], 'y':p[1]}
  })
  let data = {
    datasets: [{
      data: p,
      backgroundColor: 'rgb(0, 150, 255)',
      borderColor: 'rgb(0, 150, 255)',
      showLine: true,
      tension: 0.0,
      pointRadius: 2,
      borderWidth: 3
    }],
  };
  
  let ctx = document.getElementById(element).getContext('2d');

  return new Chart(ctx, {
    type: 'scatter',
    data: data,
    options: {
      scales: {
        x: {
          type: 'linear',
          position: 'bottom',
          ticks: {
            beginAtZero: true,
            max: 100
          },
          min: 0,
          max: points[points.length - 1].x
        },
      },
      plugins: {
        legend: {
          display: false,
        } 
      } 
    },
  })
}

// don't call this - don't scroll when page loads
//onBeamSelected(1)
beams[1].SetupImages();
beams[1].SetupDimensionForm(1);
calculate(1);